export default {
  male: {
    title: {
      en: 'Scentbird Monthly Cologne Subscription Box: Designer Scents $14.95',
    },
    description: {
      en: `
        Discover the latest colognes for men at Scentbird. Explore over 500 designer fragrances.
        A huge selection of designer and niche colognes. Monthly supply of Designer Cologne delivered to your door for just $14.95.
        Free shipping.
      `,
    },
  },
  female: {
    title: {
      en: 'Scentbird Monthly Perfume Subscription Box: Designer Scents $14.95',
    },
    description: {
      en: `
        Discover the latest perfumes and colognes at Scentbird. Date perfumes before marrying them.
        Explore over 500 designer fragrances. Get new designer scent every month for just $14.95.
        Free shipping.
      `,
    },
  },
}
